export function selectToTypeahead(select, { onChange }) {
  // Build a list of options to search against
  const options = Array.from(select.options).map(option => ({ id: option.value, label: option.text }));
  const initialValue = select.selectedIndex >= 0 ? {
    id: select.options[select.selectedIndex].value,
    label: select.options[select.selectedIndex].text
  } : null;

  window.typeAhead(select, {
    fieldName: select.name,
    fieldId: select.id,
    initialSearch: true,
    initialValue,
    searchFunc: function (searchTerm) {
      if (searchTerm === '') { return options; }

      return options.filter(option => {
        return option.label.toLowerCase().startsWith(searchTerm.toLowerCase())
      });
    },
    onChange
  });
}